import { Plus, Trash2 } from "lucide-react";
import { CatFace } from "@/components/yarn/Cat";

export function SavedCats({ cats, active, editing, max, onEdit, onActivate, onDelete, onNew }) {
  return (
    <div className="patch p-5 space-y-4" data-testid="saved-cats">
      <div className="flex items-center justify-between gap-2">
        <p className="font-display text-sm uppercase tracking-widest text-[var(--yarn-muted)]">Your cats · {cats.length}/{max}</p>
        <button className="btn-soft h-9 px-3 text-xs inline-flex items-center gap-1" onClick={onNew} disabled={cats.length >= max} data-testid="new-cat-button">
          <Plus size={14} /> New cat
        </button>
      </div>
      {cats.length === 0 ? (
        <p className="text-sm text-[var(--yarn-muted)]" data-testid="no-saved-cats">No saved cats yet. Dress one up and save it.</p>
      ) : (
        <ul className="grid grid-cols-2 gap-2">
          {cats.map((c) => (
            <li key={c.id} className={`rounded-2xl border-2 p-3 flex flex-col items-center gap-2 transition-colors ${editing === c.id ? "border-[var(--yarn-terracotta)] bg-[#FFF4EC]" : "border-[var(--yarn-stitch)] bg-white"}`} data-testid={`saved-cat-${c.id}`}>
              <button className="flex flex-col items-center gap-1" onClick={() => onEdit(c)} data-testid={`edit-cat-${c.id}`}>
                <CatFace look={c} size={58} />
                <span className="font-display text-sm truncate max-w-[110px]">{c.name}</span>
              </button>
              <div className="flex items-center gap-1">
                {active === c.id ? (
                  <span className="text-xs font-display text-[var(--yarn-sage)] px-2" data-testid={`active-cat-badge-${c.id}`}>Wearing</span>
                ) : (
                  <button className="btn-soft h-8 px-3 text-xs" onClick={() => onActivate(c.id)} data-testid={`use-cat-${c.id}`}>Use</button>
                )}
                <button className="h-8 w-8 grid place-items-center rounded-full hover:bg-red-50 text-red-700 transition-colors" onClick={() => onDelete(c.id)} aria-label={`Delete ${c.name}`} data-testid={`delete-cat-${c.id}`}>
                  <Trash2 size={14} />
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
